export default function TS_React() {
  return (
    <div>
      <h1>TS with React</h1>
      <p>This is the TS with React page.</p>
    </div>
  );
}